import { render, staticRenderFns } from "./Task.vue?vue&type=template&id=66810a6f"
import script from "./Task.vue?vue&type=script&lang=js"
export * from "./Task.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian-bitbucket-pipelines-runner/8cc7fca4-30ca-5724-915b-9e55d5143525/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66810a6f')) {
      api.createRecord('66810a6f', component.options)
    } else {
      api.reload('66810a6f', component.options)
    }
    module.hot.accept("./Task.vue?vue&type=template&id=66810a6f", function () {
      api.rerender('66810a6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Dashboard/Dashboard/Stats/Task.vue"
export default component.exports